import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ResourceSelect from "../../../../../components/Inputs/ResourceSelect";
import {
	getSettingsResourceSearchFilters,
	renderSettingsResourceLabel,
} from "../../../../../utils/helpers/settings";

export const useEmployeeTypeFilter = () => {
	const { t } = useTranslation();

	return useMemo(
		() => ({
			id: "employeeType",
			Header: t("employee-type"),
			filter: "resource-select",
			canFilter: true,
			Filter: (
				<ResourceSelect
					labelPropName="description"
					renderLabel={renderSettingsResourceLabel}
					resourcePath="/employee-type"
					hasSearch
					mode="multiple"
					getSearchFilters={getSettingsResourceSearchFilters}
				/>
			),
		}),
		[t],
	);
};
